import styled from 'styled-components';
import { PageContainer } from '@dealstack/frontend/shared/layout/PageContainer/PageContainer.tsx';

export const PageAbsoluteContainer = styled(PageContainer)`
	position: absolute;
	top: 0;
	left: 0;
	background: white;
	z-index: 10;
	overflow: hidden;
`;
